'use client';

import { c as _c } from "react/compiler-runtime";
import { useHideHeader } from '@/components/header/hide-header-context';
import React, { type ReactNode } from 'react';

/**
 * Client wrapper for the header that conditionally hides it based on context.
 * On desktop (xl+), the header is always visible even if hideHeader is true.
 */
export const HeaderClientWrapper: React.FC<{
  children: ReactNode;
}> = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  const {
    hideHeader
  } = useHideHeader();
  if (hideHeader) {
    let t1;
    if ($[0] !== children) {
      t1 = <div className="hidden xl:block">{children}</div>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== children) {
    t1 = <>{children}</>;
    $[2] = children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};